var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page dashboard-page"},[(_vm.isSuperRole)?_c('div',[_c('SuperHome')],1):(_vm.isNoneRole)?_c('div',[_c('NoneRoleHome')],1):_c('div',[_c('ApplicationHome')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }